import dynamic from 'next/dynamic';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components';

import withSentry from '../utils/withSentry';
import Layout from '../layout';
import FlexBox from '../components/FlexBox';
import HotMarkets from '../components/HotMarkets';
import MarketSymbolsList from '../components/MarketSymbolsList';
import lightTheme from '../themes/light';

import GetIndexPageInitialProps from '../network/GetIndexPageInitialProps';

const TradingDataProvider = dynamic(import('../network/TradingDataProvider'), {
  ssr: false,
  loading: () => null,
});
const UserDataProvider = dynamic(import('../network/UserDataProvider'), {
  ssr: false,
  loading: () => null,
});
const RateDataProvider = dynamic(import('../network/RateDataProvider'), {
  ssr: false,
  loading: () => null,
});

const RecommendBox = styled.div`
  margin: 0;
  margin-top: 40px;
  user-select: none;

  .market-item {
    background: #fff;
    box-shadow:0px 0px 20px 0px rgba(0,0,0,0.04);
    border-radius:3px;

    :hover {
      box-shadow:0px 0px 20px 0px rgba(0,0,0,0.15);
    }
  }
`;

const MarketsBox = styled(FlexBox)`
  user-select: none;
`;

const DivStyle = styled.div`
 width: 100%;
`;


const ContainerStyle = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  // min-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  width: 100%;
  @media screen and (max-width: 1200px) {
    &{
      max-width: auto;
      min-width: auto;
      padding: 0 20px;
    }
  }
  @media screen and (max-width: 768px) {
    &{
      padding: 0;
    }
  }
`;

// TODO replace antd component theme globally here
const GlobalStyle = createGlobalStyle`
  .ant-tooltip-placement-top .ant-tooltip-arrow {
    border-top-color: #fff;
  }
  .ant-tooltip-inner {
    background-color: #fff;
    color: #000;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    max-width: inherit;
  }
`;

const mapStateToProps = ({
  isLoggedIn, locale, news, tickers, selectedPair, theme,
}) => ({
  isLoggedIn,
  locale,
  news: news[locale],
  tickers,
  selectedPair,
  theme,
});

export default
@connect(mapStateToProps)
@withSentry
class IndexPage extends Component {
  static propTypes = {
    theme: PropTypes.string.isRequired,
    isLoggedIn: PropTypes.bool,
    symbols: PropTypes.array,
    tickers: PropTypes.object,
    selectedPair: PropTypes.string,
    locale: PropTypes.string,
    news: PropTypes.array,
    wssUri: PropTypes.string.isRequired,
    metaData: PropTypes.shape({
      title: PropTypes.string.isRequired,
      keywords: PropTypes.string,
      description: PropTypes.string,
    }),
    Recommends: PropTypes.array.isRequired,
    hostName: PropTypes.string,
    ServerTime: PropTypes.number.isRequired,
  };

  static defaultProps = {
    symbols: [],
    tickers: {},
    selectedPair: 'BTC_USDT',
    locale: 'en',
    news: [],
    metaData: {},
  };

  static getInitialProps = GetIndexPageInitialProps;

  render() {
    const {
      locale,
      metaData,
      Recommends,
      wssUri,
      selectedPair,
      hostName,
    } = this.props;
    return (
      <ThemeProvider theme={lightTheme}>
        <Layout
          hostName={hostName}
          locale={locale}
          metaData={metaData}
          isShowMoreNews={false}
          isGreyBg={true}
          hasQuestionCallback={false}
          selectedPair={selectedPair}
          shouldHeaderFixed={true}
          withJpush={true}
          isCompatibleMobile={true}
        >
          <GlobalStyle />
          <UserDataProvider both={null} wssUri={wssUri} />
          <TradingDataProvider wssUri={wssUri} />
          <RateDataProvider />
          <DivStyle>
            <ContainerStyle>
              <RecommendBox>
                <HotMarkets/>
              </RecommendBox>
              <MarketsBox justify="center">
                <MarketSymbolsList />
              </MarketsBox>
            </ContainerStyle>
          </DivStyle>
        </Layout>
      </ThemeProvider>
    );
  }
}
